import { render, staticRenderFns } from "./LinkEntity.vue?vue&type=template&id=4bd5bd1c&scoped=true&"
import script from "./LinkEntity.vue?vue&type=script&lang=js&"
export * from "./LinkEntity.vue?vue&type=script&lang=js&"
import style0 from "./LinkEntity.vue?vue&type=style&index=0&id=4bd5bd1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd5bd1c",
  null
  
)

export default component.exports